import Swiper from "swiper/bundle";

var swiper = new Swiper(".mySwiper", {
  lazy: true,
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 40,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
});

var swiperActu = new Swiper(".swiperActu", {
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 20,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
});


var swiperEnseigne = new Swiper(".diaporama_enseigne", {
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
});

var swiperHoraires = new Swiper(".widget-daily-events", {
  direction: "vertical",
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
});